import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Query } from '@angular/core';
import { IAppConfig } from '../Config/app-config.model';
import { AgencyAction } from '../../shared/model/AgencyAction.model';
import { Observable } from 'rxjs';
import { StateAgency } from 'src/app/shared/model/StateAgency.model';

@Injectable({
  providedIn: 'root'
})
export class ActionService {
  
  constructor(private httpParameter: HttpClient, @Inject('appconfig') private config: IAppConfig) { }
  
  GetActions(): Observable<AgencyAction[]> {
    return this.httpParameter.get<any>(`${this.config.ApiConfig.API_ENDPOINT}Action/GetByAgencyId`);
  }
  
  GetActionsByAgenciesIds(stateAgencies: StateAgency[]) : Observable<AgencyAction[]> {
    let QueryStr = '';
    stateAgencies.forEach(stateAgency => {
      QueryStr = QueryStr == ''? '?agenciesId=' + stateAgency.agencyId: QueryStr + '&agenciesId=' +stateAgency.agencyId     
    })
    return this.httpParameter.get<any>(`${this.config.ApiConfig.API_ENDPOINT}Action/GetByAgencyIds${QueryStr}`);
  }
}
